import script from "./ClubHighlightSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubHighlightSetup.vue?vue&type=script&setup=true&lang=js"

import "./ClubHighlightSetup.vue?vue&type=style&index=0&id=30a31af0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a31af0"]])

export default __exports__